var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.2832,
    y: 7.5,
    width: 9.81359,
    height: 0.833333,
    rx: 0.416667,
    fill: "#717070"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.2832,
    y: 7.5,
    width: 9.81359,
    height: 0.833333,
    rx: 0.416667,
    fill: "#717070"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.2832,
    y: 10.8335,
    width: 15.0627,
    height: 0.833333,
    rx: 0.416667,
    fill: "#717070"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.2832,
    y: 14.1667,
    width: 15.0627,
    height: 0.833333,
    rx: 0.416667,
    fill: "#717070"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2.2832,
    y: 17.5,
    width: 15.0627,
    height: 0.833333,
    rx: 0.416667,
    fill: "#717070"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.2832,
    y: 20.8333,
    width: 15.0627,
    height: 0.833333,
    rx: 0.416667,
    fill: "#717070"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5297 4.37508C17.5297 5.89795 16.1626 7.20842 14.3781 7.20842C12.5937 7.20842 11.2266 5.89795 11.2266 4.37508C11.2266 2.85221 12.5937 1.54175 14.3781 1.54175C16.1626 1.54175 17.5297 2.85221 17.5297 4.37508Z",
    stroke: "#717070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1772 5.06982C15.1772 5.00635 15.1674 4.94938 15.1479 4.89893C15.13 4.84684 15.0958 4.79964 15.0454 4.75732C14.9949 4.71338 14.9241 4.67025 14.833 4.62793C14.7418 4.58561 14.6238 4.54167 14.479 4.49609C14.3178 4.44401 14.1648 4.38542 14.02 4.32031C13.8768 4.25521 13.7498 4.17952 13.6391 4.09326C13.5301 4.00537 13.4438 3.90365 13.3803 3.78809C13.3185 3.67253 13.2876 3.53825 13.2876 3.38525C13.2876 3.23714 13.3201 3.10286 13.3852 2.98242C13.4503 2.86035 13.5415 2.75618 13.6587 2.66992C13.7758 2.58203 13.9142 2.51449 14.0737 2.46729C14.2348 2.42008 14.4114 2.39648 14.6035 2.39648C14.8655 2.39648 15.0942 2.44368 15.2895 2.53809C15.4848 2.63249 15.6362 2.76188 15.7436 2.92627C15.8527 3.09066 15.9072 3.27865 15.9072 3.49023H15.1797C15.1797 3.38607 15.1577 3.29492 15.1137 3.2168C15.0714 3.13704 15.0063 3.07438 14.9184 3.02881C14.8322 2.98324 14.7231 2.96045 14.5913 2.96045C14.4643 2.96045 14.3585 2.97998 14.2739 3.01904C14.1893 3.05648 14.1258 3.10775 14.0835 3.17285C14.0411 3.23633 14.02 3.30794 14.02 3.3877C14.02 3.44792 14.0346 3.50244 14.0639 3.55127C14.0949 3.6001 14.1404 3.64567 14.2006 3.68799C14.2609 3.73031 14.3349 3.77018 14.4228 3.80762C14.5107 3.84505 14.6124 3.88167 14.728 3.91748C14.9217 3.97607 15.0918 4.04199 15.2382 4.11523C15.3864 4.18848 15.5101 4.27067 15.6093 4.36182C15.7086 4.45296 15.7835 4.55632 15.8339 4.67188C15.8844 4.78743 15.9096 4.91846 15.9096 5.06494C15.9096 5.21956 15.8795 5.35791 15.8193 5.47998C15.7591 5.60205 15.672 5.7054 15.5581 5.79004C15.4441 5.87467 15.3082 5.93896 15.1504 5.98291C14.9925 6.02686 14.8159 6.04883 14.6206 6.04883C14.4448 6.04883 14.2714 6.02604 14.1006 5.98047C13.9297 5.93327 13.7742 5.86247 13.6342 5.76807C13.4959 5.67367 13.3852 5.55322 13.3022 5.40674C13.2192 5.26025 13.1777 5.08691 13.1777 4.88672H13.9126C13.9126 4.9974 13.9297 5.09098 13.9638 5.16748C13.998 5.24398 14.046 5.30583 14.1079 5.35303C14.1714 5.40023 14.2462 5.43441 14.3325 5.45557C14.4204 5.47673 14.5164 5.4873 14.6206 5.4873C14.7475 5.4873 14.8517 5.4694 14.9331 5.43359C15.0161 5.39779 15.0771 5.34814 15.1162 5.28467C15.1569 5.22119 15.1772 5.14958 15.1772 5.06982Z",
    fill: "#717070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66202 4.58333V0.5H18.899V24.5H0.5V5.08333H6.16202H6.66202V4.58333Z",
    stroke: "#717070"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 7.67968,
    y2: -0.5,
    transform: "matrix(-0.80238 0.596813 -0.665911 -0.746031 6.16211 0)",
    stroke: "#717070"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceFile);
export default __webpack_public_path__ + "static/media/service-file.3cade630866af80a66ec7a2baef09f48.svg";
export { ForwardRef as ReactComponent };